import parse from 'html-react-parser';
import { Card, CardContent, Grid, Link, Typography } from '@mui/material';
import { useMyIntl } from 'my-intl';

import { styles } from './constants';

import './bsic.scss';

function BSIC() {
  const linkUnderline = 'hover';
  const linkPadding = '0.75rem';
  const textPadding = '0.5rem 1rem';

  const { translateMessage } = useMyIntl();

  return (
    <Grid container id={styles.ids.bsic}>
      <Grid className="linksContainer">
        <Grid size={{ xs: 0, md: 4, lg: 6 }}>
          <img src="images/bsic_back.jpg" alt="BSIC" className="high-res-img" />
        </Grid>
        <Grid size={{ xs: 12, md: 8, lg: 6 }}>
          <img src="images/bsic_back.jpg" alt="BSIC" className="low-res-img" />
          <Typography
            className="title"
            component="div"
            variant="h2"
            color={styles.title.color}
            fontFamily={styles.title.font.secondary}
          >
            <strong>{translateMessage('bsic.title')}</strong>
          </Typography>
          <Card sx={{ backgroundColor: 'transparent' }}>
            <CardContent sx={{ display: 'flex', flexDirection: 'column' }}>
              <Grid padding={linkPadding} color={styles.link.color.secondary}>
                <strong>{translateMessage('bsic.announcement')}</strong>&nbsp;-&nbsp;
                <Link
                  href={translateMessage('bsic.announcementInternationalPath')}
                  color={styles.link.color.secondary}
                  target="_blank"
                  underline={linkUnderline}
                >
                  {translateMessage('bsic.announcementInternational')}
                </Link>
              </Grid>
              <Grid padding={linkPadding} color={styles.link.color.secondary}>
                <strong>{translateMessage('bsic.announcement')}</strong>&nbsp;-&nbsp;
                <Link
                  href={translateMessage('bsic.announcementInternclubPath')}
                  color={styles.link.color.secondary}
                  target="_blank"
                  underline={linkUnderline}
                >
                  {translateMessage('bsic.announcementInternclub')}
                </Link>
              </Grid>
              <Grid padding={linkPadding} color={styles.link.color.secondary}>
                <strong>{translateMessage('bsic.forms')}</strong>
                &nbsp;-&nbsp;
                <Link
                  href={translateMessage('bsic.formsPath')}
                  color={styles.link.color.secondary}
                  target="_blank"
                  underline={linkUnderline}
                >
                  {translateMessage('bsic.forms')}
                </Link>
              </Grid>
              <Grid color={styles.link.color.secondary} padding={linkPadding}>
                <strong>{translateMessage('bsic.detailedProgram')}</strong>
                &nbsp;-&nbsp;
                <Link
                  href={translateMessage('bsic.detailedProgramPath')}
                  color={styles.link.color.secondary}
                  target="_blank"
                  underline={linkUnderline}
                >
                  {translateMessage('bsic.detailedProgram')}
                </Link>
              </Grid>
              <Grid padding={linkPadding} color={styles.link.color.secondary}>
                <strong>{translateMessage('bsic.entriesResults')}</strong>&nbsp;-&nbsp;
                <Link
                  href={translateMessage('bsic.entriesResultsISUPath')}
                  color={styles.link.color.secondary}
                  target="_blank"
                  underline={linkUnderline}
                >
                  {translateMessage('bsic.entriesResultsISU')}
                </Link>
                /
                <Link
                  href={translateMessage('bsic.entriesResultsInterclubPath')}
                  color={styles.link.color.secondary}
                  target="_blank"
                  underline={linkUnderline}
                >
                  {translateMessage('bsic.entriesResultsInterclub')}
                </Link>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <br />
      <Grid container size={12} padding={'2rem 4rem'}>
        <Card sx={{ backgroundColor: 'transparent' }}>
          <CardContent>
            <Typography component="div" color={styles.title.color} padding={textPadding}>
              {parse(translateMessage('bsic.text'))}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}

export default BSIC;
